<template>
  <div
    id="app"
    :style="[organization ? { '--background': theme.background, '--foreground': theme.foreground, '--accent': theme.accent, '--accent2': theme.accent2 } : '', theme.headline ? { '--display': theme.headline, '--headline-weight': theme.headlineWeight } : '']"
    class="segment1-manual app">
    <app-header v-if="user.users.selectedOrganization"/>
    <div
      v-if="!userLoading"
      class="main">
      <router-view/>
    </div>
    <app-footer/>
    <lw-loader
      v-if="loading"
      :class="'loading'"/>
  </div>
</template>

<script>
import Header from './components/common/Header.vue'
import Footer from './components/common/Footer.vue'
import * as firebase from 'firebase'
import sync from './components/mixins/sync'
import Loader from './components/livewires/Loader'
import { mapState, mapGetters } from 'vuex'

export default {
  name: 'App',
  components: {
    appHeader: Header,
    appFooter: Footer,
    lwLoader: Loader
  },
  mixins: [sync],
  data () {
    return {
      background: '#DCDBD7',
      foreground: '#322E2F',
      accent: '#FF592D',
      accent2: '#0031CE',
      headline: '"neue-haas-grotesk-display", var(--sans)',
      headlineWeight: 'var(--bold)'
    }
  },
  computed: {
    ...mapState([
      'user',
      'userLoading',
      'organization'
    ]),
    ...mapGetters([
      'organization'
    ]),
    loading () {
      return this.$store.state.loading
    },
    theme () {
      if (this.organization.theme) {
        let weight = this.headlineWeight
        if (this.organization.theme.headlineWeight) {
          weight = 'var(--' + this.organization.theme.headlineWeight + ')'
        }
        return {
          background: this.organization.theme.background,
          foreground: this.organization.theme.foreground,
          accent: this.organization.theme.accent,
          accent2: this.organization.theme.accent2,
          headline: '"' + this.organization.theme.headline + '", "neue-haas-grotesk-display", var(--sans)',
          headlineWeight: weight
        }
      } else {
        return {
          background: this.background,
          foreground: this.foreground,
          accent: this.accent,
          accent2: this.accent2,
          headline: this.headline,
          headlineWeight: this.headlineWeight
        }
      }
    }
  },
  beforeCreate () {
    firebase.default.auth().onAuthStateChanged((user) => {
      // this.$store.dispatch('toggleLoading', true)
      if (user && this.$route.path === '/') {
        this.$router.replace('/loading')
      } else if (!user && this.$route.path !== '/') {
        this.$router.replace('/')
      }
    })
  }
}
</script>

<style>
  .main,
  .app {
    min-height: calc(100vh - (var(--page-margin) * 4.25));
  }
  .loading {
    z-index: 1000;
  }
</style>
